import { connect } from "vuex-connect";
import { ContentsAddLink } from "../../../components";

export default connect({
  stateToProps: {
    isBusy: state => state.common.isBusy,
    previewUrl: state => state.myContents.previewUrl
  },
  actionsToProps: {
    getContentsPageList: (dispatch, value) =>
      dispatch("myContents/getContentsPageList", value),
    postContentsAddLink: (dispatch, value) =>
      dispatch("myContents/postContentsAddLink", value),
    saveContentsAddLink: (dispatch, value) =>
      dispatch("myContents/saveContentsAddLink", value),
    deleteContentsAddLink: (dispatch, value) =>
      dispatch("myContents/deleteContentsAddLink", value),
    saveContentsLinkSettings: (dispatch, value) =>
      dispatch("myContents/saveContentsLinkSettings", value),
    saveContentsLinkSettingsPreview: (dispatch, value) =>
      dispatch("myContents/saveContentsLinkSettingsPreview", value)
  },
  mutationsToProps: {
    setIsBusy: "common/setIsBusy"
  }
})(ContentsAddLink.name, ContentsAddLink);
